import { IsNumber, IsString } from 'class-validator';

export class AuthResponse {
    @IsString()
    token!: string;

    @IsNumber()
    userId!: number;

    // @IsString()
    // userType!: string;

    @IsString()
    firstName!: string;

    @IsString()
    lastName!: string;

    @IsString()
    email!: string;

    // @IsNumber()
    // entityType!: number;
}
